export default __webpack_public_path__ + "static/media/group-579@3x.e15fa7bb.png";